/*
  Soovie site fixes (replaces the old Shrine bundle that used to live in this file).
  The old bundle re-declared code already loaded by global.js, so browsers rejected
  it on every page. This file keeps only what the site still needs:
  1. internal-video: play / sound / timeline controls for testimonial videos.
  2. Mobile sticky Add to Cart: visible whenever the main Add to Cart button is off-screen.
*/

/* 1. internal-video */
if (!customElements.get('internal-video')) {
  class InternalVideo extends HTMLElement {
    constructor() {
      super();
      this.playButton = this.querySelector('.internal-video__play');
      this.soundButton = this.querySelector('.internal-video__sound-btn');
      this.video = this.querySelector('video');
      this.timeline = this.querySelector('.internal-video__timeline');
      this.dragging = false;
      if (!this.video) return;

      if (this.playButton) this.playButton.addEventListener('click', this.playVideo.bind(this));
      if (this.soundButton) this.soundButton.addEventListener('click', this.toggleSound.bind(this));
      this.video.addEventListener('ended', this.endedVideo.bind(this));

      if (this.timeline) {
        this.video.addEventListener('timeupdate', this.updateTimeline.bind(this));
        this.timeline.addEventListener('click', this.seekVideo.bind(this));
        this.timeline.addEventListener('mousedown', this.startDrag.bind(this));
        this.timeline.addEventListener('touchstart', this.startDrag.bind(this));
        document.addEventListener('mouseup', this.stopDrag.bind(this));
        document.addEventListener('touchend', this.stopDrag.bind(this));
        document.addEventListener('mousemove', this.drag.bind(this));
        document.addEventListener('touchmove', this.drag.bind(this));
      }

      this.video.addEventListener('waiting', this.showSpinner.bind(this));
      this.video.addEventListener('canplaythrough', this.hideSpinner.bind(this));
      this.video.addEventListener('play', this.hideSpinner.bind(this));

      if (this.dataset.autoplay === 'true' && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { root: null, rootMargin: '0px', threshold: 0.05 });
        this.observer.observe(this);
      }
    }
    playVideo() {
      if (this.video.paused) {
        this.video.play();
        this.classList.add('internal-video--playing');
      } else {
        this.video.pause();
        this.classList.remove('internal-video--playing');
      }
    }
    endedVideo() { this.classList.remove('internal-video--playing'); }
    toggleSound() {
      this.video.muted = !this.video.muted;
      this.classList.toggle('internal-video--muted', this.video.muted);
    }
    updateTimeline() {
      if (!this.video.duration) return;
      this.style.setProperty('--completed', (this.video.currentTime / this.video.duration) * 100 + '%');
    }
    startDrag(e) { e.preventDefault(); this.dragging = true; this.drag(e); }
    stopDrag() { this.dragging = false; }
    drag(e) {
      if (!this.dragging) return;
      if (e.touches) e = e.touches[0];
      this.seekVideo(e);
    }
    seekVideo(e) {
      const rect = this.timeline.getBoundingClientRect();
      const ratio = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
      if (this.video.duration) this.video.currentTime = ratio * this.video.duration;
    }
    showSpinner() { this.classList.add('internal-video--loading'); }
    hideSpinner() { this.classList.remove('internal-video--loading'); }
    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        this.video.querySelectorAll('source[data-src]').forEach((source) => {
          source.setAttribute('src', source.getAttribute('data-src'));
          source.removeAttribute('data-src');
        });
        this.video.load();
        this.video.play();
        this.observer.disconnect();
      });
    }
  }
  customElements.define('internal-video', InternalVideo);
}

/* 2. Mobile sticky Add to Cart */
(function () {
  function init() {
    var sticky = document.querySelector('sticky-atc.sticky-atc');
    var mainButtons = document.querySelector('.product-form__buttons');
    if (!sticky || !mainButtons || !('IntersectionObserver' in window)) return;

    var style = document.createElement('style');
    style.textContent =
      '@media screen and (max-width: 749px){' +
      'sticky-atc.sticky-atc.sv-sticky-on{transform:translateY(0) !important;}' +
      'sticky-atc.sticky-atc.sv-sticky-off{transform:translateY(100%) !important;}' +
      '}';
    document.head.appendChild(style);

    new IntersectionObserver(function (entries) {
      var inView = entries[0].isIntersecting;
      sticky.classList.toggle('sv-sticky-on', !inView);
      sticky.classList.toggle('sv-sticky-off', inView);
    }, { threshold: 0 }).observe(mainButtons);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
